"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const v0 = (0, utils_1.buildTypes)({
    types: {
        ReactionId: "u64",
        ReactionKind: {
            _enum: ["Upvote", "Downvote"],
        },
        Reaction: {
            id: "ReactionId",
            created: "WhoAndWhen",
            updated: "Option<WhoAndWhen>",
            kind: "ReactionKind",
        },
    }
});
exports.default = [v0];
